import { appNameConstants } from '../../constants/app-constants'
import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export function getAllRoles() {
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  headers['App-Name'] = appNameConstants.CLIENT_PORTAL
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.get('/roles')
}
